<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>{{ $t("confirm-email-title") }}</h1>
        <div>
          <p v-if="message">{{ message }}</p>
          <p v-else-if="failed">
            {{ $t("confirm-link-invalid") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmEmail from "@/services/authentication/confirm"

export default {
  name: "RegisterConfirm",
  data() {
    return {
      confirmed: false,
      failed: false,
      message: null,
    }
  },
  computed: {
    codeParam() {
      // get code query param named "code" from window.location
      return window.location.search.split("Code=")[1] ?? null
    },
  },
  async created() {
    if (!this.codeParam) {
      this.failed = true
    }
    const result = await confirmEmail(this.codeParam)

    if (result.message) {
      this.message = result.message
      this.$toasted.show(result.message)
    }
  },
}
</script>

<style></style>
